<template>
    <div>
        <vapp-header btnClose btnContactBusinessCreate contact></vapp-header>
        <div class="container pr-5 pb-5 pl-5 pt-2 d-flex flex-column">
            <div class="switch">
                <md-switch v-model="customer">Customer</md-switch>
                <md-switch v-model="supplier">Supplier</md-switch>
            </div>
            <form class="w-100 form-fnc" autocomplete="off">
                <label>Business Name*</label>
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-icon-company.svg">
                    <input v-if="isMY" type="text" class="form-control" placeholder="e.g. Orange Sdn Bhd" v-model="business_name"
                           v-bind:class="{ 'is-invalid': attemptSubmit && missingBusinessName }">
                    <input v-if="isSG" type="text" class="form-control" placeholder="e.g. Orange Pte Ltd" v-model="business_name"
                           v-bind:class="{ 'is-invalid': attemptSubmit && missingBusinessName }">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'business_name'">{{ error.text }}</div>
                </div>

                <label>Company Registration No.</label>
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-user-solid.svg">
                    <input v-if="!isSG" type="text" class="form-control" placeholder="SSM Company Registration No." v-model="company_reg_no">
                    <input v-if="isSG" type="text" class="form-control" placeholder="SSM Company Registration No. (UEN)" v-model="company_reg_no">
                </div>

                <label>Email</label>
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-at-solid.svg">
                    <input type="text" v-if="!isSG" class="form-control" placeholder="hello@gmail.com.my" v-model="email" v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }">
                    <input type="text" v-if="isSG" class="form-control" placeholder="hello@gmail.com.sg" v-model="email" v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
                </div>

                <label>Website URL</label>
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-icon-website.svg">
                    <input type="text" v-if="!isSG" class="form-control" placeholder="www.website.com.my" v-model="website">
                    <input type="text" v-if="isSG" class="form-control" placeholder="www.website.com.sg" v-model="website">
                </div>

                <label>Office Telephone Number</label>
                <div class="input-group">
                    <img class="img-icon" src="@/assets/images/ct-icon-telephone.svg">
                    <input type="text" v-if="!isSG" class="form-control" placeholder="Please enter a valid number" v-model="office_telephone">
                    <input type="text" v-if="isSG"  class="form-control" placeholder="+65 6505 6582" v-model="office_telephone">
                </div>

                <!-- <label>Official Whatsapp Number</label>
                <div class="input-group">
                  <img class="img-icon" src="@/assets/images/ct-icon-telephone.svg">
                  <div class="row">
                    <div class="col">
                      <select class="custom-select mr-sm-2 padding-override" v-model="whatsapp_number">
                        <option disabled value="">Select Country Code</option>
                      </select>
                    </div>

                    <div class="col">
                      <input type="text" class="form-control padding-override" placeholder="123456789">
                    </div>
                  </div>
                </div> -->

                <div class="row section-border">
                </div>

                <div role="tablist" class="contact-accordion">
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" role="tab">
                            <b-btn href="#" block v-b-toggle.contactperson style="box-shadow: inset 0px 0px white">
                                <img src="@/assets/images/ct-user-solid.svg" />
                                Contact Person
                                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
                        </b-card-header>

                        <b-collapse id="contactperson" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <label>Display Name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="e.g. Dave" v-model="cp_display_name">
                                </div>

                                <label>Email</label>
                                <div class="input-group">
                                    <input type="email" class="form-control padding-override" placeholder="e.g. dave@mail.com" v-model="cp_email">
                                </div>

                                <label>Phone No.</label>
                                <div class="input-group">
                                    <input v-if="!isSG" type="number" class="form-control padding-override" placeholder="0123456778" v-model="cp_phone">
                                    <input v-if="isSG" type="number" class="form-control padding-override" placeholder="+65 6505 6582" v-model="cp_phone">
                                </div>

                                <label>First Name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="e.g. Dave" v-model="cp_first_name">
                                </div>

                                <label>Last Name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="e.g. Bautista" v-model="cp_last_name">
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <div class="row section-border">
                    </div>

                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" role="tab">
                            <b-btn href="#" block v-b-toggle.address style="box-shadow: inset 0px 0px white">
                                <img src="@/assets/images/ct-icon-map.svg" />
                                Address
                                <img class="float-right" src="@/assets/images/angle-down-solid.svg" /></b-btn>
                        </b-card-header>

                        <b-collapse id="address" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <label v-if="!isSG">Street</label>
                                <label v-if="isSG">Block No & Street Name</label>
                                <div class="input-group">
                                    <input type="text" v-if="!isSG" class="form-control padding-override" placeholder="e.g. Baker Street" v-model="street">
                                    <input type="text" v-if="isSG" class="form-control padding-override" placeholder="e.g. Blk 35 Mandalay Road" v-model="street">
                                </div>

                                <label v-if="!isSG">City</label>
                                <label v-if="isSG">Floor, Apartment No & Building Name</label>
                                <div class="input-group">
                                    <input v-if="!isSG" type="text" class="form-control padding-override" placeholder="e.g. KD" v-model="city">
                                    <input v-if="isSG" type="text" class="form-control padding-override" placeholder="e.g. # 13–37 Mandalay Towers" v-model="city">
                                </div>

                                <label v-if="!isSG">State</label>
                                <label v-if="isSG">Town / City / State</label>
                                <div class="input-group">
                                    <input v-if="!isSG" type="text" class="form-control padding-override" placeholder="e.g. Selangor" v-model="state">
                                    <input v-if="isSG" type="text" class="form-control padding-override" placeholder="e.g. Singapore" v-model="state">
                                </div>

                                <label>Postcode</label>
                                <div class="input-group">
                                    <input type="text" class="form-control padding-override" placeholder="e.g. 47810" v-model="postcode">
                                </div>

                                <label>Country</label>
                                <div class="input-group">
                                    <select class="custom-select mr-sm-2 padding-override" v-model="country">
                                        <option disabled value="null">Select Country</option>
                                        <option v-for="country in bCountries" :value="country.id" :key="country.id">{{ country.name }}</option>
                                    </select>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <div class="row section-border">
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

    export default {
        name: "CreateNewBusiness",
        data() {
            return {
                //Business
                business_name: null,
                company_reg_no: null,
                email: null,
                website: null,
                office_telephone: null,
                customer: false,
                supplier: false,

                //Contact Person
                cp_display_name: null,
                cp_email: null,
                cp_phone: null,
                cp_first_name: null,
                cp_last_name: null,

                //Address
                street: null,
                city: null,
                state: null,
                postcode: null,
                country: null,

                //Others
                attemptSubmit: false,
                errors: [],
                bCountries: [],
                currencies: null,
                isMY: false,
                isSG: false
            }
        },
        computed: {
            ...mapState('company', ['selectedCompany', 'companies']),
            missingBusinessName: function () {
                if (!this.business_name) { return true; } else { return false; }
            },
            missingEmail: function () {
                if (!this.email) { return true; } else { return false; }
            },
            invalidEmailFormat: function () {
                if (!this.validEmail(this.email)) { return true; } else { return false; }
            },
            requestData: function() {
                return {
                    owner_id: this.selectedCompany,
                    is_customer: this.customer,
                    is_supplier: this.supplier,
                    memo: null,
                    currency_id: this.getCurrencyId(this.country),
                    method_id: null,
                    term_id: null,
                    files: [],
                    supplier_currency_id: null,
                    supplier_method_id: null,
                    supplier_term_id: null,
                    entity: {
                        display_name: this.business_name,
                        email: this.email,
                        phone_no: this.office_telephone,
                        name: this.business_name,
                        reg_no: this.company_reg_no,
                        website_url: this.website,
                    },
                    send_mail: true,
                    contactpersons: [{
                        display_name: this.cp_display_name,
                        email: this.cp_email,
                        phone_no: this.cp_phone,
                        first_name: this.cp_first_name,
                        last_name: this.cp_last_name,
                    }],
                    addresses: [{
                        id: null,
                        street: this.street,
                        city: this.city,
                        state: this.state,
                        postcode: this.postcode,
                        country_id: this.country,
                        is_primary: true,
                        is_deleted: false,
                    }],
                    extras: []
                }
            }
        },
        beforeDestroy () {
            this.$root.$off('attempt_submit_create_business')
        },
        mounted() {
            console.log("Mounted : CreateBusiness");
            //get country id
            var company  = this.companies

            company.forEach(item => {
                if (item.id === this.selectedCompany){
                    if(item.country_id === 135){
                        this.isMY = true
                    } else if (item.country_id === 200){
                        this.isSG = true
                    }
                }
            });

            // get countries list and currencies list
            this.$root.$emit('show-loading', true);
            this.axios
                .get("/pre_sign_up").then(response => {
                this.$root.$emit('show-loading', false);
                this.currencies = response.data.currencies
                this.bCountries = response.data.countries

                for (var i = 0; i< this.bCountries.length; i++) {
                    if (this.bCountries[i].code == 'MY') {
                        this.country = this.bCountries[i].id
                    }
                }
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            });

            this.axios({
                method: 'post',
                url: '/lists/mixed',
                data: {
                    "requests":[
                        {
                            "uri" : "/lists/currencies",
                            "params": {
                                "company_id": this.selectedCompany
                            }
                        },
                        {
                            "uri" : "/lists/countries",
                            "params": {
                                "company_id": this.selectedCompany
                            }
                        }
                    ]
                }
            }).then(response => {
                this.$root.$emit('show-loading', false);
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            })

            // Will get call when user click on tick button top right
            // Do checking for compulsory fields first, then pop up confirmation dialog
            this.$root.$on('attempt_submit_create_business', vars => {
                this.errors = [];
                this.attemptSubmit = true;

                if (this.missingBusinessName) {
                    this.errors.push({id: 'business_name', text: "This field is compulsory"});
                }

                if (this.missingEmail) {
                    this.errors.push({id: 'email', text: "This field is compulsory"});
                }
                else if (this.invalidEmailFormat) {
                    this.errors.push({id: 'email', text: 'Valid email required.'});
                }

                if(!this.errors.length) {
                    event.preventDefault();
                    this.$confirmationToast("Create business?", "Are you sure you want to create this business?", this.createBusiness, null);
                } else {
                    event.preventDefault();
                }
            });

        },
        methods: {
            createBusiness() {
                this.$root.$emit('show-loading', true);
                this.axios({
                    method: 'post',
                    url: '/contacts/companies',
                    data: this.requestData,
                }).then(response => {
                    console.log(response)
                    this.$root.$emit('show-loading', false);
                    this.$successToast('Business successfully created.')
                    this.$router.go(-1)
                }).catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                })
            },
            getCurrencyId: function(country_id) {
                for(var i = 0; i<this.currencies.length; i++) {
                    if(this.currencies[i].country_id == country_id) {
                        let currency_id = this.currencies[i].id
                        return currency_id
                    }
                }
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        },
    }
</script>
<style scoped lang="scss">

    .section-border {
        border-bottom: 10px solid rgba(0, 0, 0, 0.1);
    }

</style>
